import { render } from "./DInput.vue?vue&type=template&id=664b6882"
import script from "./DInput.vue?vue&type=script&lang=ts"
export * from "./DInput.vue?vue&type=script&lang=ts"
script.render = render

export default script